import React from 'react';
import { Link } from 'react-router-dom';

/** Compact header for standalone pages (verification, rewards). */
export function PageHeader() {
  return <header className="sticky top-0 z-40 border-b border-white/10 bg-ink-950/95 backdrop-blur" data-id="element-999" data-mp="3cjfr2m22kxtb">
      <div className="mx-auto flex max-w-[1400px] items-center justify-between gap-4 px-4 py-3 sm:px-6 lg:px-8" data-id="element-1000" data-mp="3rduauotgkb91">
        <Link to="/" className="shrink-0" data-id="element-1001" data-mp="3mdoit7ja0mqf">
          <span className="block font-display text-2xl font-extrabold uppercase leading-none tracking-tight text-offwhite sm:text-3xl" data-id="element-1002" data-mp="2yp568ft71nsj">
            Grit<span className="text-grit-500" data-id="element-1003" data-mp="2toqzd13bwjw3">Vue</span>
            <sup className="ml-0.5 align-super text-[9px] text-steel-400" data-id="element-1004" data-mp="38fztnni6etfk">™</sup>
          </span>
          <span className="mt-0.5 block text-[8px] font-semibold uppercase tracking-[0.3em] text-steel-400 sm:text-[9px]" data-id="element-1005" data-mp="33orkmskrda2x">
            See the job through
          </span>
        </Link>
        <Link to="/#offer" className="inline-flex shrink-0 items-center bg-grit-500 px-3.5 py-2.5 font-display text-base font-extrabold uppercase leading-none tracking-wide text-ink-950 transition-[background-color,transform] duration-150 ease-grit hover:bg-grit-400 active:translate-y-[2px] sm:px-4 sm:text-lg" data-id="element-1006" data-mp="2b0vsm164w6ch">
          Get your X1
        </Link>
      </div>
    </header>;
}